import { Box, Typography } from "@mui/material";
import { ReactComponent as CheckIcon } from "../../assets/icons/small-circle-check.svg";

function CheckValidRow(props) {
  const { isValid, title, sx = [] } = props;
  return (
    <Box
      sx={[
        {
          display: "flex",
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {isValid ? (
        <CheckIcon width={12} height={12} />
      ) : (
        <Box
          sx={{
            width: 12,
            height: 12,
            bgcolor: "common.white",
            borderRadius: "100%",
            border: (theme) => `1px solid ${theme.palette.grey[2]}`,
          }}
        ></Box>
      )}
      <Typography variant="subtitle1" color="grey.4" ml={1}>
        {title}
      </Typography>
    </Box>
  );
}

export default CheckValidRow;
